export const sortByStringProp = (a: any, b: any, prop: string): number => {
    const ap = a[prop],
        bp = b[prop];
    if (ap && bp && typeof ap === 'string' && typeof bp === 'string') {
        const lap = ap.toLowerCase(),
            lbp = bp.toLowerCase();
        if (lap > lbp) {
            return 1
        } else if (lap < lbp) {
            return -1
        }
        return 0
    }
    return 1
}